"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledFooter = _styledComponents.default.footer`
    box-sizing: border-box;
    flex-shrink: 0;
    color: ${({
  theme
}) => theme.colors.footer.text};
    background-color: ${({
  theme
}) => theme.colors.footer.background};
    border-top: ${({
  theme
}) => `1px solid ${theme.colors.footer.border}`};
    height: 50px;
    line-height: 50px;
    font-size: ${({
  theme
}) => theme.fontSizes[2]};
    text-align: right;

    a {
        color: ${({
  theme
}) => theme.colors.primaryText};
        text-decoration: none;

        &:hover,
        &:active,
        &:visited {
            color: ${({
  theme
}) => theme.colors.primaryText};
            text-decoration: underline;
        }
    }

    ${_styledSystem.space}
    ${_styledSystem.layout}
    ${_styledSystem.typography}
    ${_styledSystem.color}
    ${_styledSystem.border}
    ${_styledSystem.position}
`;
var _default = StyledFooter;
exports.default = _default;